module.exports = __webpack_public_path__ + "img/profile-3.27d51717.png";